{
  "version": 1,
  "asset_id": "9f53a6f2-349c-4c4b-8df7-377ff367400a",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/9f53a6f2-349c-4c4b-8df7-377ff367400a/raindrop-self-cleaning.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/9f53a6f2-349c-4c4b-8df7-377ff367400a/raindrop-self-cleaning.mp4",
  "original_filename": "raindrop-self-cleaning.mp4",
  "size": 18302977,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:17:54Z"
}
